import {
  Component,
  OnInit,
  ViewChild,
  ViewChildren,
  QueryList,
  HostListener
} from '@angular/core';
import { SelectItem } from 'primeng/api';
import { MultiSelect } from 'primeng/multiselect';
import { Table } from 'primeng/table';
import { DocumentsType } from '../../../models/_enum-collections';
import { EngagementEditInput } from '../../../models/engagement-edit-input.model';
import { IncentivePreviewInput } from '../../../models/Incentive-preview-input.model';
import { PartnerInput } from '../../../models/partner-input.model';
import { TaskOwner } from '../../../models/task-owner.model';
import { AppConstants } from '../../common/app-constants';
import { CommonSharedModule } from '../../common/shared.module';
import { EditComponent } from '../../home/edit/edit.component';
import { LocalStorageService } from '../../services/local-storage-service';
import { OsmosisEditService } from '../../services/osmosis-edit.service';
import { OsmosisService } from '../../services/osmosis.service';
import { EditIncentiveComponent } from '../edit-incentive/edit-incentive.component';
import { IncentivePreviewComponent } from '../incentive-preview/incentive-preview.component';

@Component({
  selector: 'app-deal-association-document-queue',
  templateUrl: './deal-association-document-queue.component.html',
  styleUrls: ['./deal-association-document-queue.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    EditIncentiveComponent,
    IncentivePreviewComponent
  ]
})
export class DealAssociationDocumentQueueComponent implements OnInit {
  @ViewChild('dt', { static: false }) dt!: Table;
  @ViewChildren('tak') components!: QueryList<MultiSelect>;
  @ViewChild('editNavChild', { static: false }) editNavChild!: EditComponent;

  constructor(
    private osm: OsmosisService,
    private osmEdit: OsmosisEditService,
    public localStorage: LocalStorageService
  ) {}

  scrollableCols!: any[];
  incentiveList!: PartnerInput[];
  taskOwnerDrpdwn!: TaskOwner[];
  ftaskOwnerDrpdwn: SelectItem[] = [];

  excelLoading = false;
  loading = false;
  loadEditComponent = false;
  editNav = false;
  showFullscreen = false;
  engagementEditInput!: EngagementEditInput;
  requestDetailId!: number;
  engagementIdPassToChild!: number;
  loadingIcon = 'fa-circle-o-notch';
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  tblPageNumber!: number;
  totalRecords!: number;

  incentivePreviewInput!: IncentivePreviewInput;
  canShowPreviewModel = false;

  @HostListener('window:resize') onresize(): void {
    requestAnimationFrame(() => {
      if (document && document.querySelector('#engagementEdit')) {
        const editEngagement = document
          ?.querySelector('#engagementEdit')
          ?.querySelector<HTMLElement>('[role="dialog"]');

        if (editEngagement) {
          editEngagement.style.width = '90%';
          editEngagement.style.height = '85%';
        }
      }
    });
  }

  ngOnInit() {
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.loadEditComponent = false;
    this.editNav = false;
    this.showFullscreen = this.localStorage.getFullscreenMode();
    this.engagementEditInput = {
      showFullScreen: this.showFullscreen
    } as any;

    this.scrollableCols = [
      { field: 'engagementKey', header: 'Incentive ID', display: 'none' },
      { field: 'engagementSubType', header: 'Incentive Sub Type' },
      { field: 'taskOwner', header: 'Task Owner' },
      { field: 'partnerInputParnterName', header: 'Partner Org' },
      { field: 'partnerCountry', header: 'Partner Country' },
      { field: 'partnerInputCustomerName', header: 'Customer Org' },
      { field: 'partnerInputCustomerCountry', header: 'Customer Country' },
      { field: 'fiscalYear', header: 'Fiscal Year' },
      { field: 'l1InternalStatus', header: 'L1InternalStatus' },
      { field: 'opsStatus', header: 'L2InternalStatus' },
      { field: 'uploadedDate', header: 'Uploaded Date' }
    ];

    this.loadDealAssociationDocList();
    this.getTaskOwnerList();
  }

  loadDealAssociationDocList() {
    this.loading = true;
    this.osm.getDealAssociationDocumentsForAdvisorIncentives().subscribe(
      serviceOutput => {
        this.incentiveList = serviceOutput;
        this.loading = false;
      },
      () => {
        this.incentiveList = [];
        this.totalRecords = 0;
        this.loading = false;
      }
    );
  }

  getTaskOwnerList() {
    this.osmEdit.getTaskOwnerDropDown().subscribe(PTList => {
      this.taskOwnerDrpdwn = PTList;
      for (const item of this.taskOwnerDrpdwn) {
        const ftaskOwnerDrpdwn: SelectItem = {
          label: item.taskOwner,
          value: item.taskOwner
        };
        this.ftaskOwnerDrpdwn.push(ftaskOwnerDrpdwn);
      }
    });
  }

  editRequestDetails(engementId: number) {
    this.loadEditComponent = true;
    this.editNav = true;
    this.requestDetailId = engementId;
    this.engagementIdPassToChild = engementId;
    this.engagementEditInput.engagementId = engementId;
    this.engagementEditInput.isOptOutPartner = this.incentiveList.find(
      x => x.engagementKey === engementId
    )?.isOptOutPartner;
  }

  onShowFullScreenChanged(showFullscreenValue: boolean) {
    this.showFullscreen = showFullscreenValue;
    this.localStorage.setFullscreenMode(this.showFullscreen);
  }

  onCloseEditModal() {
    this.loadEditComponent = false;
    this.editNav = false;
  }

  export() {
    //need to implement after completing User Story: 17902
    return;
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    this.pageChange({ first: 0 });
  }

  reset() {
    this.components['_results'].forEach(ds => {
      ds.value = null;
    });

    if (this.dt) {
      this.dt.filter('', 'taskOwner', 'in');
      this.dt.filter('', 'engagementType', 'in');
      this.dt.reset();
    }

    this.loadDealAssociationDocList();
  }

  get currentPageInfo(): string {
    if (this.incentiveList != null && this.totalRecords == undefined) {
      this.totalRecords = this.incentiveList.length;
    }
    if (this.totalRecords === 0) {
      return 'No Record Found';
    } else if (
      this.tblPageNumber + this.dataViewRecsPerPage >
      this.totalRecords
    ) {
      return (
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else if (
      this.tblPageNumber + this.dataViewRecsPerPage <=
      this.totalRecords
    ) {
      return (
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else if (
      this.totalRecords > 0 &&
      this.totalRecords > this.dataViewRecsPerPage
    ) {
      return (
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      return (
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else {
      return '';
    }
  }

  previewFile(engagementId) {
    const selectedIncentive = this.incentiveList.find(
      engagement => engagement.engagementKey === engagementId
    );

    this.incentivePreviewInput = {
      engagementId: engagementId,
      engagementIdList: this.incentiveList.map(
        engagement => engagement.engagementKey
      ) as number[],
      previewFileIndex: 0,
      documentTypeId: DocumentsType.DealAssociationTemplate,
      incentiveName: '',
      customerOrgName: selectedIncentive?.partnerInputCustomerName || '',
      partnerOrgName: selectedIncentive?.partnerInputParnterName || '',
      partnerInputRequestorEmail: '',
      committedDate: new Date(),
      isPoePreview: false
    };

    this.canShowPreviewModel = true;
  }

  closePreview() {
    this.canShowPreviewModel = false;
    this.loadDealAssociationDocList();
    this.incentivePreviewInput = {} as IncentivePreviewInput;
  }

  refresh() {
    this.loadDealAssociationDocList();
  }
}
